import FormatorImageModelCommon from 'common/models/formator-image';

export default class FormatorImageModel extends FormatorImageModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'formator-image': FormatorImageModel;
  }
}
